import { connect } from 'react-redux'
import PresentersChatPanel from './PresentersChatPanel'
import chatActions from '../../dataStore/actions/chat'
import selectChatPanelActive from '../../dataStore/selectors/selectChatPanelActive'
import { State } from '../../dataStore/reducers/reducerType'
import selectParticipantInformationMap from '../../dataStore/selectors/selectParticipantInformationMap'
import { PresenterChatPanelProps } from './types'

type Dispatch = 'newMessageReceived'| 'setChatMessageCounter'| 'resetChatMessageCounter'

const mapStateToProps = (state: State): Omit<PresenterChatPanelProps, Dispatch> => ({
  isPanelActive: selectChatPanelActive(state),
  participantInformation: selectParticipantInformationMap(state),
  token: state.config.token,
  username: state.config.username,
  conversationName: `${state.config.roomname}-conversation`,
  roomname: state.config.roomname,
  BTID: state.user.BTID
})

const mapDispatchToProps = (dispatch): Pick<PresenterChatPanelProps, Dispatch> => ({
  newMessageReceived: () => dispatch(chatActions.increaseChatMessageCounter()),
  setChatMessageCounter: count => dispatch(chatActions.setChatMessageCounter(count)),
  resetChatMessageCounter: () => dispatch(chatActions.resetChatMessageCounter())
})

export default connect(mapStateToProps, mapDispatchToProps)(PresentersChatPanel)
